import PropTypes from "prop-types";
import React from "react";
import styled, { css } from "styled-components";
import { rem } from "polished";

const StyledHomepageH3 = styled.h3`
  font-family: ${({ theme }) => theme.primaryFont};
  ${({ theme }) => theme.ADAFont("28px")}
  font-weight: 500;
  color: #343638;

  ${({ theme }) => theme.tablet`
      font-size: ${rem("19px")};
   `}

  // Terms pages
   ${({ section }) =>
    section == "terms" &&
    css`
      text-align: center;
      margin-bottom: ${rem("16px")};
    `}

   // Agent Enrollment Page
   ${({ section }) =>
    section == "agent" &&
    css`
      ${({ theme }) => theme.ADAFont("26px")}
      text-align: center;
      margin-bottom: ${rem("8px")};
    `}

   // Contact Us Page
   ${({ section }) =>
    section == "contactUs" &&
    css`
      ${({ theme }) => theme.ADAFont("21px")}
      text-align: center;
      margin-bottom: ${rem("16px")};
    `}

   // Email Preferences
   ${({ section }) =>
    section == "emailPreferences" &&
    css`
      ${({ theme }) => theme.ADAFont("22px")};
      text-align: left;
      margin-bottom: ${rem("20px")};
    `}
`;

const HomepageH3 = ({ section, children }) => {
  return (
    <StyledHomepageH3 section={section} children={children}>
      {children}
    </StyledHomepageH3>
  );
};

HomepageH3.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,

  section: PropTypes.string,
};

export default HomepageH3;
